import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsAdobelightroomclassicComponent } from './simple-icons-adobelightroomclassic.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsAdobelightroomclassicComponent ],
    exports:      [ SimpleIconsAdobelightroomclassicComponent ],
    bootstrap:    []
})
export class SimpleIconsAdobelightroomclassicModule {}
